import { render, staticRenderFns } from "./allocateRanking.vue?vue&type=template&id=4965dfe4&scoped=true&"
import script from "./allocateRanking.vue?vue&type=script&lang=js&"
export * from "./allocateRanking.vue?vue&type=script&lang=js&"
import style0 from "./allocateRanking.vue?vue&type=style&index=0&id=4965dfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965dfe4",
  null
  
)

export default component.exports